import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Cadastro de Turmas',
    path: '/academico/turma',
    name: 'cadastroTurmas',
    component: () => import('@/views/academico/turma/Cadastro/Index.vue'),
    meta: {
      permissions: [
        eTipoPermissao.TURMAS_MENU_300600701
      ],
    },
    goesToMenu: true,
  },

  {
    description: 'Cadastro de Turmas',
    path: '/academico/turma/cadastro/:id?',
    parent: 'cadastroTurmas',
    name: 'cadastroTurmas_create',
    component: () => import('@/views/academico/turma/Cadastro/InclusaoEdicao.vue'),
    meta: {
      permissions: [
        eTipoPermissao.TURMAS_MENU_300600701
      ],
      routeOnChangeEscolaAnoSemestre: 'cadastroTurmas'
    },
  },
]

